import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UserService } from '../services/user.service';
import { User } from '../models/user.model';
import { Role } from '../models/role.model';
import { GLOBAL } from '../services/global';
import { VariableService } from '../services/sharedVariables';
import { RoleService } from '../services/role.service';
import { Privileges } from '../models/privileges.model';

@Component({
  selector: 'user',
  templateUrl: '../views/admin/user.html',
  providers: [UserService,RoleService]
})
export class UserComponent{
  public title: string;
  public users: User[];
  public submitUserModel: User;
  public roles: Role[];
  public message: any;
  public mode: string;
  public wait:boolean;
  public customerPrivilege:number;
  public privileges:Privileges[];

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private userService: UserService,
    public sharedVariables: VariableService,
    private roleService: RoleService
  )
  {

      this.title = null;
      this.mode = "submit-add";
      this.submitUserModel = new User(0,'','',0);
      this.wait = true;
      this.customerPrivilege = null;

  }

  ngOnInit()
  {
    console.log("mode",this.mode);
    console.log(this.sharedVariables);
    this.sharedVariables.validSession();
    setTimeout(()=> {
              if(this.sharedVariables.login){
                this.getPrivileges();
                console.log(this.privileges);
                setTimeout(()=> {
                                  if(this.customerPrivilege == 1){
                                    this.getAllUsers();
                                    this.getRoles();
                                    this.wait = false;
                                  }
                                  else{
                                  this.title = "Permisos insuficientes para el usuario";
                                  this.wait=false;
                                }
                                },this.sharedVariables.timeToLoad);
    }
    else
      this.title = "Error, Sesión no iniciada";
    },this.sharedVariables.sessionTime);
  }

  getAllUsers()
  {
    this.userService.getUsers().subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
        }else{
          this.users = result.data;
          console.log(this.users);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }

  getRoles()
  {
    this.roleService.getRoles().subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
        }else{
          this.roles = result.data;
          console.log(this.roles);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }

  onSubmit()
  {
    if(this.mode == "submit-add")
    {
      this.saveUser();
    }else{
      this.updateUser();
    }
    setTimeout(()=> {
                      this.message = null;
                    },this.sharedVariables.timeMessage);
    setTimeout(()=> {
                      this.getAllUsers();
                      this.submitUserModel = new User(0,'','',0);
                    },this.sharedVariables.timeToLoad);
    this.mode = "submit-add";
    console.log("mode",this.mode);
  }

  saveUser()
  {
    this.userService.addUser(this.submitUserModel).subscribe(
      response => {
        if(response.code == 200)
        {
          this.message = response.data;
        }else
        {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  editUser(pUser: User)
  {
    this.mode = "submit-update";
    this.submitUserModel = Object.assign({}, pUser);

    console.log("Checkout objects");
    console.log(this.submitUserModel);
    console.log("mode",this.mode);
  }

  updateUser()
  {
    /*this._route.params.forEach((params: Params)=>{*/
      let id = this.submitUserModel.ID;
      console.log("objeto update ",this.submitUserModel);
      this.userService.updateUser(id,this.submitUserModel).subscribe(
        response => {
          if(response.code == 200)
          {
            this.message = response.data;
          }else
          {
            console.log(response);
          }
          },
          error => {
            console.log(<any>error);
          }
        );
      /*});*/
  }

  deleteUser(id: number)
  {
    this.userService.deleteUser(id).subscribe(
        response => {
          if(response.code == 200){
            this.getAllUsers();
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }
  cleanObject()
  {
    this.submitUserModel = this.submitUserModel = new User(0,'','',0);
  }
  getPrivileges()
  {
    this.sharedVariables.getPrivileges().subscribe(
        response => {
          if(response.code == 200){
            this.customerPrivilege = response.data[0].Customer;
            console.log("Privilegios del usuario",this.customerPrivilege);
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }
  showMessage()
  {
    this.message = "hola";
  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/components/user.component.ts